module.exports = __webpack_public_path__ + "static/media/addSquares.7c476fda.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/addSquares.svg
// module id = 231
// module chunks = 0